import {
  BeakerIcon,
  AcademicCapIcon,
  BriefcaseIcon,
  MegaphoneIcon,
  SparklesIcon,
  AtSymbolIcon,
  HeartIcon,
  UserIcon,
  ShieldCheckIcon,
  BuildingOfficeIcon,
  BanknotesIcon
} from "@heroicons/react/24/solid";

export const navLinks = [
  {
    label: "Products",
    isDropdown: true,
    dropdownContent: [
      {
        title: "PSTVue",
        href: "https://www.mnr-pst.com",
        icon: AcademicCapIcon,
        description: "Learning, Redefined",
      },
      {
        title: "ClipCut",
        href: "https://mnr-clipcut.com",
        icon: AtSymbolIcon,
        description: "AI Video Editor",
      },
      {
        title: "AT Vue",
        href: "https://www.mnr-at.com",
        icon: BeakerIcon,
        description: "Testing, Redefined",
      },
      {
        title: "Doctor AI",
        href: "https://www.mnr-doctorai.com",
        icon: HeartIcon,
        description: "HealthCare, Redefined",
      },
      {
        title: "AI Worker",
        href: "https://mnr-ai-worker.vercel.app",
        icon: UserIcon,
        description: "Digital Employee",
      },
      {
        title: "Denti AI",
        href: "https://www.mnr-denti.com",
        icon: SparklesIcon,
        description: "Dental AI Assistant",
      },
      {
        title: "Leadgen",
        href: "https://www.mnr-leadgen.com",
        icon: MegaphoneIcon,
        description: "Grow Your Business",
      },
      {
        title: "Job Portal",
        href: "https://www.mnr-jobs.com",
        icon: BriefcaseIcon,
        description: "Career Opportunities",
      },
      {
        title: "Bot Sheild",
        href: "https://mnr-bot-shield.vercel.app",
        icon: ShieldCheckIcon,
        description: "AI-Powered Bot Protection",
      },
            {
        title: "Farm to Fork",
        href: "https://www.mnr-farmtofork.com",
        icon: ShieldCheckIcon,
        description: "AI-Powered Farming",
      },


      //https://www.mnr-msme.com, https://www.mnr-kosten.com  for all this websites redesign is completed including font matching with mnr tech webs site
      {
  title: "MSME",
  href: "https://www.mnr-msme.com",
  icon: BuildingOfficeIcon,
  description: "AI-Enabled Solutions for MSME Lifecycle Support",
},
{
  title: "Kosten",
  href: "https://www.mnr-kosten.com",
  icon: BanknotesIcon,
  description: "Expense Management System",
},
    ],
  },
  {
    label: "Events",
    href: "/events",
    isDropdown: false,
  },
  {
    label: "Gallery",
    href: "/gallery",
    isDropdown: false,
  },
  {
    label: "Testimonials",
    isDropdown: false,
    href: "/testimonials",
  },
  {
    label: "About Us",
    isDropdown: false,
    href: "/about-us",
  },
  {
    label: "Contact Us",
    isDropdown: false,
    href: "/contact",
  },
];
